import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { Backdrop as i, Box as c, Typography as s, CircularProgress as a } from "@mui/material";
const p = ({ text: o, open: e }) => /* @__PURE__ */ r(
  i,
  {
    sx: (l) => ({ color: "#fff", zIndex: l.zIndex.drawer + 1 }),
    open: e,
    children: /* @__PURE__ */ n(c, { sx: { display: "flex", flexFlow: "column", gap: 2, alignItems: "center" }, children: [
      o && /* @__PURE__ */ r(s, { children: o }),
      /* @__PURE__ */ r(a, { color: "inherit" })
    ] })
  }
);
export {
  p as LoadingOverlay
};
//# sourceMappingURL=index.js.map
